import { render, staticRenderFns } from "./ImageButtonSettings.vue?vue&type=template&id=71a2b3ee&scoped=true&"
import script from "./ImageButtonSettings.vue?vue&type=script&lang=js&"
export * from "./ImageButtonSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a2b3ee",
  null
  
)

export default component.exports